








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AppRegularLink extends Vue {
  @Prop({ type: String, default: '' })
  readonly to!: string;

  @Prop({ type: String, default: '' })
  readonly mod!: string;

  get modClasses(): Array<string> {
    const { mod } = this;
    if (!mod.length) return [];
    return mod.split(', ').map((item) => `app-link_${item}`);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/links/AppRouterLink/AppRouterLink.vue